import React, { Component } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import * as aserver from '../../APIClient';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import Link from '@material-ui/core/Link';
import Box from '@material-ui/core/Box';
import { PasswordDiv, HandlePasswordEditChange } from "../../Utilities";
import wavybackground from "../images/wavy-pattern.jpg"
import leaf from "../images/Leaf.png"
import Logo from "../images/Aephoria-logo-blue-login.png"

function Copyright() {
  return (
    <Typography variant="body2" color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://aephoriagroup.com/">
      Aephoria Partners      
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100vh',
  },
  image: {
    backgroundImage: `url(${wavybackground})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  },
  lefthandSide: {
    width: '100%', /* Or specify your desired width */
    height: '100%', /* Or specify your desired height */
    position: 'relative',
    overflow: 'hidden',
    display: 'flex',
  },

  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

// eslint-disable-next-line 
class ResetPassword extends Component {  constructor(props) {
    super(props);
    this.state = {
      password: "",
      confirmPassword:"",
      showPassword: false,
      resetCode: "",
      error:[],
      success:[],
      confirmPasswordSuccess:[],
      confirmPasswordError:[],
      passwordGoodToGo:false,
    };
  }

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  handleClickShowPassword = () => {
    this.setState({ showPassword: !this.state.showPassword });
  };

  handlePassword = (e)=>{
    HandlePasswordEditChange(e, this, this.state.password, this.state.confirmPassword, false)
  }

  submitNewPassword=async()=>{
      if (this.state.passwordGoodToGo){
        let submitPassword = await aserver.post("api/v2/resetpassword",{
          resetcode: this.state.resetCode,
          newpassword: this.state.confirmPassword,
        })
        if(submitPassword.data.success === true){
          alert('Your password was successfully reset. You can now log into the coach portal. ')
          aserver.goto('/coachportal/login')
        }else{
          alert(submitPassword.data.error)
          aserver.goto('/coachportal/login')
        }
      }else{
        alert("Update failed - there is an issue with the new password - please check and fix.")
      }
  }

  componentDidMount=()=>{
    let search = window.location.search
    this.setState({
      resetCode:  search.split("=")[1]
    })
  }

  render() {
    const classes = this.props.classes;
    //const {error, success, confirmPasswordSuccess, confirmPasswordError} = this.state;

    return (
            <>
            <Grid container component="main" className={classes.root}>
              <CssBaseline />
              <Grid item xs={false} sm={false} md={6} className="leftHandSide LeftImage">
                <img item xs={false} sm={false} className='mainLoginImage' src={Logo} alt="aephoria-logo"/> 
                <img  item xs={false} sm={false} className='leafLoginImage' src={leaf} alt="aephoria-logo"/>
              </Grid>              
              <Grid className='loginGrid' item xs={12} sm={12} md={6} component={Paper} elevation={6} square>                
              <div className='login-paper'>
              <img className='loginImage' style={{display:"none"}} src={Logo} alt="aephoria-logo"/>
              <Avatar className={classes.avatar}>
                    <LockOutlinedIcon />
                  </Avatar>
                  <Typography component="h1" variant="h5">
                    Reset Password
                  </Typography>
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="New Password"
                    type={this.state.showPassword ? 'text' : 'password'}
                    id="password"
                    autoComplete="current-password"
                    value={this.state.password}
                    onChange={(e)=>this.handlePassword(e)}
                    InputProps={{
                      endAdornment:(
                      <InputAdornment position="end" >
                      <IconButton
                        aria-label="Toggle password visibility"
                        onClick={this.handleClickShowPassword}
                        onMouseDown={this.handleMouseDownPassword}
                      >
                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                      </InputAdornment>
                      )
                    }}
                  />
                  <TextField
                    variant="outlined"
                    margin="normal"
                    required
                    fullWidth
                    name="confirmPassword"
                    label="Confirm Password"
                    type={this.state.showPassword ? 'text' : 'password'}
                    id="confirmPassword"
                    autoComplete="current-password"
                    value={this.state.confirmPassword}
                    onChange={(e)=>this.handlePassword(e)}
                    InputProps={{
                      endAdornment:(
                      <InputAdornment position="end" >
                      <IconButton
                        aria-label="Toggle password visibility"
                        onClick={this.handleClickShowPassword}
                        onMouseDown={this.handleMouseDownPassword}
                      >
                        {this.state.showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                      </InputAdornment>
                      )
                    }}
                  />
                  <PasswordDiv component={this}/>      
                    <Button
                      type="submit"
                      fullWidth
                      variant="contained"
                      color="primary"
                      className={classes.submit}
                      onClick={this.submitNewPassword}
                    >
                      Submit
                    </Button>
                    <Box mt={5}>
                      <Copyright />
                    </Box>
                </div>
              </Grid>
            </Grid>
            </>
    );
  }
}
 
// eslint-disable-next-line
export default () => {
    const classes = useStyles();
    return (
        <ResetPassword classes={classes} />
    )
};